import React, { useState, useEffect } from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import { useParallax } from 'react-scroll-parallax';

import useWindowSize from '@nubank/www-latam-commons/utils/hooks/useWindowSize';
import ImagePreload from '@nubank/www-latam-commons/components/ImagePreload/ImagePreload';

import FormBox from '../../../../components/FormBox/FormBox';

import {
  StyledBackgroundImage,
  StyledContainerBox,
  StyledImage,
  TitleContainer,
  CustomTitle,
  FormBoxContainer,
  ImageContainer,
} from './Styled';

const HERO_IMAGE = {
  xs: 'credit-card/hero/hero-xs.png',
  lg: 'credit-card/hero/hero-lg.png',
};

function Hero() {
  const { ref } = useParallax({ easing: 'easeInCubic' });
  const [screenHeight, setScreenHeight] = useState(0);
  const { width } = useWindowSize();

  useEffect(() => {
    setScreenHeight(window.innerHeight);
  }, []);

  return (
    <>
      <ImagePreload srcSet={HERO_IMAGE} />
      <Box
        tag="section"
        minHeight={{ xs: '100vh', lg: 'auto' }}
        height={{ xs: '100%', lg: '100vh' }}
      >
        <StyledContainerBox
          background={{
            xs: 'linear-gradient(137.07deg, #9F2DEB 42.83%, #6200A3 86.85%)',
            lg: 'linear-gradient(99.92deg, #9F2DEB 18.57%, #6200A3 71.77%)',
          }}
          borderRadius={{ xs: '0px 0px 20px 20px', lg: '0' }}
          height={{ xs: '98vh', lg: '85vh' }}
          paddingTop={{ xs: '60px', lg: '80px' }}
        >
          {/* TITLE (Desktop contains formbox) */}

          <TitleContainer>
            <CustomTitle>
              La tarjeta de
              {' '}
              <div><span>crédito</span></div>
              {' \n'}
              sin anualidad ni
              {' \n'}
              cobros sorpresa
            </CustomTitle>

            <FormBoxContainer
              display={{ xs: 'none', lg: 'flex' }}
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              paddingBottom={{ xs: '4x', lg: '0' }}
              marginTop={{ xs: '4vh', lg: '0' }}
            >
              <FormBox
                ctaLabel="CREDIT_CARD.HERO.SUBTITLE"
                inputTransparentBackground
                inputBoxShadow="0 0 29px rgb(130 10 209 / 10%)"
                inputLabelColor="white"
                inputLabel="HOME.CREDIT_VARIANT.FORMBOX.PLACEHOLDER"
                buttonStyleVariant="white"
              />
            </FormBoxContainer>

          </TitleContainer>

          {/* CARD AND BACK IMAGES */}

          <ImageContainer
            marginTop={{ xs: '30px', lg: '40px' }}
            position="relative"
            ref={ref}
          >
            <StyledBackgroundImage
              alt="Imagen de circulos con motivo decorativo"
              webP={false}
              src="credit-card/hero/circles.svg"
            />

            <StyledImage
              alt="Imagen de dos tarjetas de credito Nu alineadas al centro"
              srcSet={HERO_IMAGE}
              screenHeight={screenHeight}
              screenWidth={width}
            />
          </ImageContainer>

          {/* EMAIL FORM BOX */}

          <FormBoxContainer
            display={{ xs: 'flex', lg: 'none' }}
            flexDirection="column"
            alignItems={{ xs: 'center' }}
            justifyContent={{ xs: 'center' }}
            paddingBottom={{ xs: '4x', lg: '0' }}
            marginTop={{ xs: '4vh', lg: '0' }}
          >
            <FormBox
              ctaLabel="CREDIT_CARD.HERO.SUBTITLE"
              inputTransparentBackground
              inputBoxShadow="0 0 29px rgb(130 10 209 / 10%)"
              inputLabelColor="white"
              inputLabel="HOME.CREDIT_VARIANT.FORMBOX.PLACEHOLDER"
              buttonStyleVariant="white"
            />
          </FormBoxContainer>
        </StyledContainerBox>

      </Box>
    </>
  );
}

export default Hero;
